// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"455acc4b","856":"4af3b59a"}[chunkId] + ".chunk.js";
};